import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

function useStyles() {
    const { breakpoints } = useTheme()
    const { colors: color } = useContextState()
    return {
        text: {
            color: color.color33,
            '& span':{
                fontWeight: '800',
            }
        },
        container:{
            display:'flex',
            flexDirection:'column',
            gap:1
        }
    }
}

export { useStyles }